<div class="container">
    <img [src]="this.logo()" class="logo" />
    <br/>
    <edu-student-issues-home *ngIf="this.username != null" [inputUserName]="this.username"
        [inputFullName]="this.fullName"></edu-student-issues-home>
</div>